/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommentsSearchCondition { 
    pageSize?: number;
    page?: number;
    readonly listSortDirection?: CommentsSearchCondition.ListSortDirectionEnum;
    sortDirection?: string;
    sortProperty?: string;
    name?: Array<string>;
    description?: Array<string>;
    category?: Array<CommentsSearchCondition.CategoryEnum>;
}
export namespace CommentsSearchCondition {
    export type ListSortDirectionEnum = 0 | 1;
    export const ListSortDirectionEnum = {
        NUMBER_0: 0 as ListSortDirectionEnum,
        NUMBER_1: 1 as ListSortDirectionEnum
    };
    export type CategoryEnum = '0' | '1' | '2' | '3';
    export const CategoryEnum = {
        _0: '0' as CategoryEnum,
        _1: '1' as CategoryEnum,
        _2: '2' as CategoryEnum,
        _3: '3' as CategoryEnum
    };
}